import { RequireCapability } from '../../auth/RequireAuth';
import type { FeatureRoute } from '../types';
import { PlansPage } from './PlansPage';

/** Screens of this feature (A3). */
export const routes: FeatureRoute[] = [
  {
    path: 'plans',
    element: (
      <RequireCapability anyOf={['tenants.view']} what="plans">
        <PlansPage />
      </RequireCapability>
    ),
  },
];
